import { render, staticRenderFns } from "./KeyVehicleAllocation.vue?vue&type=template&id=2a3f3fd6"
import script from "./KeyVehicleAllocation.vue?vue&type=script&lang=js"
export * from "./KeyVehicleAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports